import { Anchor, Container, Paper, Text, Title } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function RegisterForm() {
  const { t } = useTranslation();

  return (
    <Container size={420} my={40} px={{ base: "xs", sm: "md" }}>
      <Title ta="center">{t("auth.createAccount")}</Title>

      <Paper
        withBorder
        shadow="md"
        p={{ base: "lg", sm: 30 }}
        mt={30}
        radius="md"
      >
        <Text ta="center" mb="md">
          {t("auth.registrationRestricted")}
        </Text>

        <Text ta="center" mt="md" size="sm">
          {t("auth.alreadyHaveAccount")}{" "}
          <Anchor
            component={Link}
            to="/login"
            data-testid="register-signin-link"
          >
            {t("auth.signIn")}
          </Anchor>
        </Text>
      </Paper>
    </Container>
  );
}
